import React from 'react';
import { useTranslation } from 'react-i18next';
import GenericTablePage from '../components/GenericTablePage';
import { GridColDef } from '@mui/x-data-grid';

const CitiesPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  
  const columns: GridColDef[] = [
    { 
      field: isArabic ? 'translation' : 'city', 
      headerName: t('cities.city'), 
      flex: 1, 
      minWidth: 200 
    },
    { 
      field: isArabic ? 'city' : 'translation', 
      headerName: isArabic ? t('cities.english') : t('cities.translation'), 
      flex: 1, 
      minWidth: 200 
    },
  ];

  const fields = [
    { 
      name: 'city', 
      label: t('cities.city'), 
      type: 'text' as const, 
      required: true 
    },
    { 
      name: 'translation', 
      label: t('cities.translation'), 
      type: 'text' as const, 
      required: true 
    },
  ];

  return (
    <GenericTablePage 
      tableName="cities"
      title={t('cities.title')}
      columns={columns}
      fields={fields}
    />
  );
};

export default CitiesPage;
